<div class="flex-vertical-center h-100">
    <div class="unauthorized text-center">
        <clr-icon shape="times-circle" class="is-solid" size="64"></clr-icon>
        <h1 translate>unauthorized</h1>
    </div>
</div>
